import { ToolCallName } from "models/enumerations/conversations/tool-call-name";
import ToolCallRecord from "models/view-models/conversations/tool-call-record";
import NotebookToolCallSuggestion from "organisms/modals/chat-modal/tool-calls/notebook-tool-call-suggestion";
import React from "react";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

interface ToolCallSuggestionsProps {
    toolCalls: ToolCallRecord[];
    messageId: string;
}

const ToolCallSuggestions = ({
    toolCalls,
    messageId,
}: ToolCallSuggestionsProps) => {
    const { allowCasiGeneratedChecklists } = useFeatureFlags();
    return (
        <>
            {toolCalls?.map((toolCall) => {
                switch (toolCall.name) {
                    case ToolCallName.BlockSuggest:
                        return allowCasiGeneratedChecklists ? (
                            <NotebookToolCallSuggestion
                                key={toolCall.toolCallId}
                                toolCall={toolCall}
                                messageId={messageId}
                            />
                        ) : (
                            <></>
                        );
                    default:
                        return <></>;
                }
            })}
        </>
    );
};

export default ToolCallSuggestions;
